import { useEffect, useState } from "react";
import * as pdfjs from "pdfjs-dist";

pdfjs.GlobalWorkerOptions.workerSrc = `${process.env.PUBLIC_URL || ""}/pdf.worker.min.mjs`;

// يحوّل كل صفحة PDF إلى صورة JPEG لتُعرض بحجم يلائم الشاشة (وجه/ظهر الهوية).
export const usePdfPages = (url) => {
  const [pages, setPages] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    let cancelled = false;
    setPages(null);
    setError(false);
    if (!url) return undefined;
    (async () => {
      try {
        const buf = await (await fetch(url)).arrayBuffer();
        const pdf = await pdfjs.getDocument({ data: buf }).promise;
        const out = [];
        for (let i = 1; i <= pdf.numPages; i += 1) {
          const page = await pdf.getPage(i);
          const viewport = page.getViewport({ scale: 2 });
          const canvas = document.createElement("canvas");
          canvas.width = viewport.width;
          canvas.height = viewport.height;
          await page.render({ canvasContext: canvas.getContext("2d"), viewport }).promise;
          out.push(canvas.toDataURL("image/jpeg", 0.92));
        }
        if (!cancelled) setPages(out);
      } catch {
        if (!cancelled) setError(true);
      }
    })();
    return () => { cancelled = true; };
  }, [url]);

  return { pages, error };
};
